// ***********************************
// Shapes.vue
// ***********************************
<template>
  <div id="app">
    <div class="container">



      <b-card header="Database Compute Shape Browser">
        <b-list-group>

          <b-list-group-item>
            <div>
              
              <b-form-group label="AWS Region for Pricing:" label-cols="4" label-size="sm">
                <b-form-select v-model="regionCode" size="sm" @change="changeRegion" :options="region_lov"/>
              </b-form-group>
              
              <b-alert :show="isChinaRegion" variant="warning">
                <strong>Note:</strong> Prices are in Chinese Yuan, not US dollars.
              </b-alert>
              <b-alert :show="isChinaRegion" variant="warning">
                <strong>Beta:</strong> DBCSI support for pricing for the Chinese AWS regions is beta and experimental. You should manually reconfirm pricing outside of DBCSI.
              </b-alert>
              
              <b-form-group label="Database Type" label-cols="4" label-size="sm" 
                v-b-tooltip.hover="'This tells DBCSI the type of Shapes you want to browse'">
                <b-form-select v-model="databaseType" size="sm" @change="changeDatabaseType">
                  <option value="EC2">Oracle on EC2</option>
                  <option value="ec2fsxn">Oracle on EC2 Bare Metal</option>
                  <option value="--" disabled>------------------------------------------------</option>
                  <option value="RDS">RDS-Oracle (BYOL)</option>
                  <option value="RDS-SE2">RDS-Oracle Standard Edition (License Included)</option>
                  <option v-if="false" value="RDS-Custom">RDS Custom for Oracle (BYOL)</option>
                  <option value="--" disabled>------------------------------------------------</option>
                  <option value="Aurora">Aurora PostgreSQL</option>
                  <option value="--" disabled>------------------------------------------------</option>
                  <option value="Db2">RDS-Db2 (BYOL)</option>
                </b-form-select>
              </b-form-group>
              
              <!--<b-form-group label="Optimize CPU Preference" label-cols="4" label-size="sm" -->
              <!--  v-b-tooltip.hover="'This affects the default sorting.'">-->
              <!--  <b-form-select v-model="form.optgoal_algo" size="sm" @change="changeDatabaseType">-->
              <!--    <option value="Y">Use Optimize CPU</option>-->
              <!--    <option value="min_license">Ignore Optimize CPU - sort by VCPU first, then cost</option>-->
              <!--  </b-form-select>-->
              <!--</b-form-group>-->
              <!--<b-form-group label="AWS Pricing Preference:" label-cols="4" label-size="sm" -->
              <!--  v-b-tooltip.hover="'This affects the default sorting in cases where no Reserved Instance prices are available.'">-->
              <!--  <b-form-select v-model="form.useRI_algo" size="sm" @change="changeDatabaseType">-->
              <!--    <option value="RI">Use 1yr No-Upfront Reserved Instance pricing if available</option>-->
              <!--    <option value="OD">Use On-Demand pricing</option>-->
              <!--  </b-form-select>-->
              <!--</b-form-group>-->

              <b-form-group label="Shape Name Filter" label-cols="4" label-size="sm">
                <b-form-input
                  type="text"
                  v-model="shapeNameFilter"
                  class="col-6"
                  size="sm"
                  placeholder="Enter part of a shape name to optionally filter"
                  @change="changeDatabaseType"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="VPCUs" label-cols="4" label-size="sm">
                <b-form-input
                  type="number"
                  v-model="ec2.VCPU"
                  class="col-6"
                  size="sm"
                  placeholder="Type to Search"
                  @change="changeDatabaseType"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Memory (GB)" label-cols="4" label-size="sm">
                <b-form-input
                  type="number"
                  v-model="ec2.Memory"
                  class="col-6"
                  size="sm"
                  placeholder="Type to Search"
                  @change="changeDatabaseType"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Throughput (MB/s)" label-cols="4" label-size="sm">
                <b-form-input
                  type="number"
                  v-model="ec2.Throughput"
                  class="col-6"
                  size="sm"
                  placeholder="Type to Search"
                  @change="changeDatabaseType"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="IOPS" label-cols="4" label-size="sm">
                <b-form-input
                  type="number"
                  v-model="ebs.IOPS"
                  class="col-6"
                  size="sm"
                  placeholder="Enter desired IOPS"
                  @change="changeDatabaseType"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="" label-cols="4" label-size="sm">
                 <b-form-checkbox
                        v-model="showMatchesOnly"
                        size="sm"
                        class="col-6"
                        value="Y"
                        unchecked-value="N"
                        @input="changeDatabaseType"
                      >
                        Show only matching shapes in table
                  </b-form-checkbox>              
              </b-form-group>

                <!--<b-pagination-->
                <!--  :total-rows="shape_list.length"-->
                <!--  :per-page="perPage"-->
                <!--  v-model="currentInputPage"-->
                <!--  size="sm"-->
                <!--  align="center"-->
                <!--/>-->
                                  <!--:per-page="perPage"-->
                  <!--:current-page="currentInputPage"-->

                <b-table
                  ref="table"
                  sticky-header="600px"
                  striped
                  hover
                  responsive
                  bordered
                  :items="shape_list"
                  :fields="inputFields"
                  :sort-by.sync="inputSortBy"
                  :sort-desc.sync="inputSortDesc"
                  class="table table-sm"
                >

                  <template #cell(Name)="row">
                    <!--<div v-b-popover.hover="`${row.item.InstanceStorage}`" title="InstanceStorage">{{ row.item.Name }}</div>-->
                    <div>{{ row.item.Name }}</div>
                    <span style="font-size:12px" v-if="(row.item.InstanceStorage!=null) && (row.item.InstanceStorage!='EBS only') && ( databaseType!='RDS' || (row.item.InstanceStorageGB!=null) )" v-b-popover.hover="`${row.item.InstanceStorage}`" title="Instance Storage">{{ row.item.InstanceStorage }}</span>
                    <span v-if="(databaseType=='RDS-SE2') && (row.item.Name=='x2iedn.4xlarge')"><br/>Multi-AZ Only</span>
                    <span v-if="(databaseType=='RDS') && (showRatio)">Ratio: {{ Math.round(10*row.item.OracleOD / row.item.LinuxOD)/10 }}, {{ Math.round(10*row.item.Oracle1yrNURI / row.item.Linux1yrNURI)/10 }} </span>
                  </template>
                  
                  <template #cell(VCPU)="row">
                    <div v-b-popover.hover="{title:`Processor`, content:`${row.item.Clockspeed} ${row.item.Processor}<br/>Older Generation Factor: ${row.item.GenFactor}`, html: true}">{{ row.item.VCPU }}</div>
                    <span style="font-size:12px" v-if="false && ( (databaseType=='RDS') || (databaseType=='EC2') ) && (row.item.OptimizeVCPUs!=null) && (row.item.OptimizeVCPUs.indexOf(',')>=0)" v-b-popover.hover="`Optimize CPU is available for these VCPU choices  [ ${row.item.OptimizeVCPUs} ]`" title="Optimize CPU">Optimize CPU</span>
                    <br/>
                    <span style="font-size:12px" v-if="(databaseType=='ec2fsxn') && (row.item.OracleCoreFactor*1<1) && (row.item.OracleCoreFactorConfidence=='yes')" 
                      v-b-popover.hover="{title:`Core Factor Friendly?`, content:`Your customers should review <a href='https://www.oracle.com/assets/processor-core-factor-table-070634.pdf' target='_blank'>https://www.oracle.com/assets/processor-core-factor-table-070634.pdf</a> and decide if the ${row.item.Processor} CPU matches ${row.item.OracleCoreFactorString? 'what the document lists as: ' + row.item.OracleCoreFactorString : 'the CPUs listed in the document.'}`, html: true}"
                      >CFF (0.5)</span>
                    <span style="font-size:12px" v-if="(databaseType=='ec2fsxn') && (row.item.OracleCoreFactor*1<1) && (row.item.OracleCoreFactorConfidence=='maybe')" 
                      v-b-popover.hover="{title:`Core Factor Friendly????`, content:`Your customer should review <a href='https://www.oracle.com/assets/processor-core-factor-table-070634.pdf' target='_blank'>https://www.oracle.com/assets/processor-core-factor-table-070634.pdf</a> and decide if the ${row.item.Processor} CPU matches ${row.item.OracleCoreFactorString? 'what the document lists as: ' + row.item.OracleCoreFactorString : 'the CPUs listed in the document.'}`, html: true}"
                      >CFF (0.5)??</span>  
                    <span style="font-size:12px" v-if="(databaseType=='ec2fsxn') && (row.item.OracleCoreFactor*1==1) " 
                      v-b-popover.hover="{title:`Not Core Factor Friendly?`, content:`Your customer should review <a href='https://www.oracle.com/assets/processor-core-factor-table-070634.pdf' target='_blank'>https://www.oracle.com/assets/processor-core-factor-table-070634.pdf</a> and decide if the ${row.item.Processor} CPU does or does not match ${row.item.OracleCoreFactorString? 'what the document lists as: ' + row.item.OracleCoreFactorString : 'the CPUs listed in the document.'}`, html: true}"
                      >CF (1.0)??</span>
                    <br v-if="(databaseType=='ec2fsxn') && (row.item.MultiChipModule=='Yes')"/>
                    <span style="font-size:12px; font-weight:bold;" v-if="(databaseType=='ec2fsxn') && (row.item.MultiChipModule=='Yes')" 
                      v-b-popover.hover="`This is a Multi Chip Module processor, which may make it incompatible with Oracle SE2 2 socket maximum rules.`" title="Multi Chip Module"
                      >MCM</span>
                    
                  </template>
                  
                  <template #cell(GeekbenchCoreScoreRounded)="row">
                    <span v-if="(databaseType=='ec2fsxn') && (row.item.GeekbenchCoreScoreRounded)" 
                      v-b-popover.hover="{title:`Geekbench v6 Single Core Performance`, content:`This is the <a href='https://browser.geekbench.com/search?q=ec2+metal' target='_blank'>Single Core CPU Performance benchmark (v5) from Geekbench</a>.  Higher values are better.  In some cases, the score has been harmonized to give different shapes using the same CPU (such as x2iezn and m5zn) the same exact value to make shape selection work better.  You can click on the score to see the actual benchmark report that was the original source of data.`, html: true}"
                      ><a :href=row.item.GeekbenchURL target="_blank">{{ row.item.GeekbenchCoreScoreRounded }}</a></span>    
                  </template>


                  <template #cell(Throughput)="row">
                    <div>{{ row.item.Throughput }}</div>
                    <span style="font-size:12px" v-if="(row.item.BaselineThroughput*1>0)">Baseline={{row.item.BaselineThroughput}}</span>
                      <img v-if="( row.item.Throughput*1 > 16000 && databaseType!='EC2' && databaseType!='ec2fsxn' )" src="@/assets/warning.png" height="20px" v-b-popover.hover="`Currently, the maximum achievable IO Throughout for RDS-Oracle is limited at the EBS storage layer to 16000 MB/s for io2 storage, even if the EC2 compute shape is rated for higher amounts.`" title="Maximum IO Throughput"></img>
                    
                  </template>

                  <template #cell(IOPS)="row">
                    <div>{{ row.item.IOPS }}</div>
                    <span style="font-size:12px" v-if="(row.item.BaselineIOPS*1>0)">Baseline={{row.item.BaselineIOPS}}</span>
                  </template>

                  <template #cell(Network)="row">
                    <div>{{ row.item.Network /8 }}</div>
                    <span style="font-size:12px" v-if="(row.item.BaselineNetwork*1>0)">Baseline= ~{{row.item.BaselineNetwork/8}}</span>
                  </template>
          

                </b-table>
                
                <br/>
                <span  style="font-size:12px" v-for="(list, index) in disclaimerLists" :key="list">
                  <span>{{ list }}</span><br/>
                </span>


      
              <!--</b-card>-->
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-card>
      
    </div>
  </div>
</template>    


<script>
import { API } from "aws-amplify";
import axios from "axios";
import {disclaimers, older_generation_factor, older_generation_cost_adjustment} from "./dbcsi_external.js";

export default {
  name: "app",
  props: ["query", "user"],
  data() {
    return {
      disclaimerLists: [],
      shape_list: [
        {
          Name: "Loading.."
        }
      ],
      shape_list_raw: [
        {
          Name: "Loading.."
        }
      ],
      showRAC: false,
      showBeta: false,
      showRatio: false,
      showMatchesOnly: "N",
      inputSortBy: "MatchXXXXXX",
      inputSortDesc: true,
      currentInputPage: 1,
      inputFields: [
        {Match: {
          label: "Match?",
          sortable: true
        }},
        {Name: {
          label: "Name",
          sortable: true
        }},
        {Reserved: {
          label: "Reserved $/hr",
          sortable: true
        }},
        {OnDemand: {
          label: "OnDemand $/hr",
          sortable: true
        }},
        {VCPU: {
          label: "VCPU",
          sortable: true
        }},
        {Memory: {
          label: "Memory GB",
          sortable: true
        }},
       {Throughput: {
          label: "Throughput MB/s",
          sortable: true
        }},
       {IOPS: {
          label: "IOPS",
          sortable: true
        }},
       {Network: {
          label: "Network MB/s",
          sortable: true
        }}
        
      ],

      perPage: 15,
      databaseType: "RDS",
      regionCode: "us-east-1",
      region_lov: [
{ value: 'af-south-1', text: 'af-south-1 Cape Town' },
{ value: 'ap-east-1', text: 'ap-east-1 Hong Kong'  },
{ value: 'ap-east-2', text: 'ap-east-1 Taipei'  },
{ value: 'ap-northeast-1', text: 'ap-northeast-1 Tokyo'  },
{ value: 'ap-northeast-2', text: 'ap-northeast-2 Seoul'  },
{ value: 'ap-northeast-3', text: 'ap-northeast-3 Osaka'  },
{ value: 'ap-south-1', text: 'ap-south-1 Mumbai'  },
{ value: 'ap-south-2', text: 'ap-south-2 Hyderabad'  },
{ value: 'ap-southeast-1', text: 'ap-southeast-1 Singapore'  },
{ value: 'ap-southeast-2', text: 'ap-southeast-2 Sydney'  },
{ value: 'ap-southeast-3', text: 'ap-southeast-3 Jakarta'  },
{ value: 'ap-southeast-4', text: 'ap-southeast-4 Melbourne'  },
{ value: 'ap-southeast-5', text: 'ap-southeast-5 Malaysia'  },
{ value: 'ap-southeast-6', text: 'ap-southeast-6 New Zealand'  },
{ value: 'ap-southeast-7', text: 'ap-southeast-7 Thailand'  },
{ value: 'ca-central-1', text: 'ca-central-1 Canada' },
{ value: 'ca-west-1', text: 'ca-west-1 Calgary' },
{ value: 'eu-central-1', text: 'eu-central-1 Frankfurt'  },
{ value: 'eu-central-2', text: 'eu-central-2 Zurich'  },
{ value: 'eu-north-1', text: 'eu-north-1 Stockholm'  },
{ value: 'eu-south-1', text: 'eu-south-1 Milan'  },
{ value: 'eu-south-2', text: 'eu-south-2 Spain'  },
{ value: 'eu-west-1', text: 'eu-west-1 Ireland' },
{ value: 'eu-west-2', text: 'eu-west-2 London'  },
{ value: 'eu-west-3', text: 'eu-west-3 Paris'  },
{ value: 'il-central-1', text: 'il-central-1 Tel Aviv'  },
{ value: 'me-central-1', text: 'me-central-1 UAE'  },
{ value: 'me-south-1', text: 'me-south-1 Bahrain'  },
{ value: 'mx-central-1', text: 'mx-central-1 Mexico'  },
{ value: 'sa-east-1', text: 'sa-east-1 Sao Paulo' },
{ value: 'us-east-1', text: 'us-east-1 N.Virginia' },
{ value: 'us-east-2', text: 'us-east-2 Ohio'  },
{ value: 'us-gov-east-1', text: 'us-gov-east-1 GovCloud US-East'  },
{ value: 'us-gov-west-1', text: 'us-gov-west-1 GovCloud US-West'  },
{ value: 'us-west-1', text: 'us-west-1 N.California'  },
{ value: 'us-west-2', text: 'us-west-2 Oregon'  }
],
      regionInfo: {region: "us-east-1", lastUpdate: "August 2, 2022"},
      shapeNameFilter: "",
      form: {
        cpu_algo: "cpu3",
        cpu_thread_ratio: "1.00",
        diskspace_algo: "disk1_plus15",
        iops_algo: "iops5",
        iomb_algo: "iomb5",
        memory_algo: "mem2_plus20_2",
        ebs_algo: "ebs1",
        rds_algo: "ee",
        tshape_algo: "N",
        optgoal_algo: "min_license",
        savedtargets_algo: "targ1",
        platform_algo: "plat1",
        aurora_algo: "auro2",
        smartscan_algo: "ss1",
        pdb_algo: "pdb1",
        useRI_algo: "RI"
      },
      ec2: {
        VCPU: "",
        Memory: "",
        Throughput: ""
      },
      ebs: {
        DiskSpace: "",
        DiskSpace_src: "",
        DiskSpace_adj_other: "",
        IOPS: "",
        Backup: "0",
        VolumeType: "gp2",
        SnapshotDays: "",
        BackupType: "none",
        aurora_IOPS_write_adj: "",
        aurora_IOPS_peak_adj: "",
        aurora_IOPS_adj: ""
      }
       
    };
  },
  
  async mounted() {
    // console.log("query",this.query);
    if (this.query != undefined) {
      var myStuff = this.query.split(':');
      myStuff = myStuff.filter(word => word!='undefined');
      if (myStuff.length>=2) {
        this.regionCode=myStuff[0];
        this.databaseType=myStuff[1];
        if (myStuff.length>=3)  {
          this.ec2.VCPU=myStuff[2]*1;
        }
        if (myStuff.length>=4) {
          this.ec2.Memory=myStuff[3]*1;
        }
        if (myStuff.length>=5) {
          this.ec2.Throughput=myStuff[4]*1;
        }  
        if (myStuff.length>=6) {
          this.ebs.IOPS=myStuff[5]*1;
        }  
      }  
        
    }
    this.changeRegion(this.regionCode);
    
    await API.get(
        "dbcsiAPI",
        `/dbcsi/permissions`
      )
        .then(response => {
          if (response.data.racOK=="Y") {
            console.log("Authorized for RAC.");      
            this.showRAC = true;
          }
        })
        .catch(error => {
          console.log("Batch-permissions Error:", error);
        });

    if ( (["dbayardAWS","amzn~dbayard"].includes(this.user))  ) {
      this.showRAC = true;
      this.showRatio = false;
    }

    if (this.query!=undefined) {
      console.log("query", this.query);
      if ( (this.query.toLowerCase().indexOf("show_rac")>=0) || (this.query.toLowerCase().indexOf("showrac")>=0) ) {
        console.log("showRAC enabled");
        this.showRAC = true;
      }
      if ( (this.query.toLowerCase().indexOf("show_beta")>=0) || (this.query.toLowerCase().indexOf("showbeta")>=0) ) {
        console.log("showBETA enabled");
        this.showBeta = true;
        // Add Chinese regions to the region LOV when beta mode is enabled
        this.region_lov.push({ value: 'cn-north-1', text: 'cn-north-1 Beijing (Beta)' });
        this.region_lov.push({ value: 'cn-northwest-1', text: 'cn-northwest-1 Ningxia (Beta)' });
      }
    }
     
  },
  
  computed: {
    isChinaRegion() {
      return this.regionCode === 'cn-north-1' || this.regionCode === 'cn-northwest-1';
    },
  },
  
  methods: {

   scrollToRow(index) {

      const tbody = this.$refs.table.$el.querySelector('tbody');
      // console.log("tbody", tbody, index);
    
      const row = tbody.querySelectorAll('tr')[index];
      // console.log("tbody", tbody, index, "row", row);
      if (row != undefined) {
        row.scrollIntoView();
      }  
    },
  
    async changeRegion(value) {
      // console.log('changeRegion',value);
      // this.showAlertRecalc = false;
      // this.showCalculateMessageFlag = true;
      this.regionCode=value;
      
    // now load Region info
      await axios
        .get("/db-"+value+".json")
        .then(response => {
          // console.log("I am here4");
          this.regionInfo = response.data;
      })
        .catch(error => {
          console.log("Shapes-Load regionInfo data Error:", error);
      });

      // now load RDS info
      this.shape_list_raw = JSON.parse(JSON.stringify(this.regionInfo.shapes));
  
      await this.changeDatabaseType(this.databaseType);

    },  //end changeRegion


    async changeDatabaseType(value) {
      // console.log('changeDatabaseType',value);
      // this.showAlertRecalc = false;
      // this.showCalculateMessageFlag = true;
      // this.databaseType=value;
      

      // reset list
      this.shape_list = JSON.parse(JSON.stringify(this.shape_list_raw));
      var typeLabel = "";

      // filter list
      if (this.databaseType=="RDS") {
        //for now, hide all tpc1 shapes until someone convinces me otherwise 
        typeLabel = "RDS-Oracle Shape";
        this.shape_list = this.shape_list.filter(value => (value.OracleOD*1 > 0) && !(value.Name.includes('tpc1')) );
      } else if (this.databaseType=="RDS-SE2") {
        //for now, hide all tpc1 shapes until someone convinces me otherwise 
        typeLabel = "License Included RDS-OracleSE2 Shape";
        this.shape_list = this.shape_list.filter(value => (value.OracleLIse2_OD*1 > 0) && !(value.Name.includes('tpc1')) );
      } else if (this.databaseType=="RDS-Custom") {
        typeLabel = "RDS Custom for Oracle Shape";
        //for now, hide all tpc1 shapes until someone convinces me otherwise 
        this.shape_list = this.shape_list.filter(value => (value.OracleCustomOD*1 > 0) && !(value.Name.includes('tpc1')) );
      } else if (this.databaseType=="EC2") {
        typeLabel = "EC2 Shape";
        //for now, hide all tpc1 shapes until someone convinces me otherwise 
        this.shape_list = this.shape_list.filter(value => (value.LinuxOD*1 > 0)  );
      } else if (this.databaseType=="ec2fsxn") {
        typeLabel = "EC2 Bare Metal Shape";
        //show only those with CoreFactor 
        this.shape_list = this.shape_list.filter(value => (value.OracleCoreFactor*1 > 0)  );  
      } else if (this.databaseType=="Aurora") {
        typeLabel = "AuroraPG Shape";
        this.shape_list = this.shape_list.filter(value => (value.AuroraPGOD*1 > 0 || value.AuroraPGOptimOD*1 > 0)  );
      } else if (this.databaseType=="Db2") {
        typeLabel = "RDS-Db2 Shape";
        this.shape_list = this.shape_list.filter(value => (value.Db2_OD*1 > 0 )  );
      }

      //set some per-row values...
      for (var ii = 0; ii < this.shape_list.length; ii++) {
         if (this.databaseType=="RDS") {
           this.shape_list[ii].OnDemand = this.shape_list[ii].OracleOD;
           this.shape_list[ii].Reserved = this.shape_list[ii].Oracle1yrNURI;
           this.shape_list[ii].SavingsPlan = this.shape_list[ii].Oracle1yrNUSP;
         } else if (this.databaseType=="RDS-SE2") {
           this.shape_list[ii].OnDemand = this.shape_list[ii].OracleLIse2_OD;
           this.shape_list[ii].Reserved = this.shape_list[ii].OracleLIse2_1yrNURI;
         } else if (this.databaseType=="RDS-Custom") {
           this.shape_list[ii].OnDemand = this.shape_list[ii].OracleCustomOD;
           this.shape_list[ii].Reserved = this.shape_list[ii].OracleCustom1yrNURI;
         } else if (this.databaseType=="EC2") {
           this.shape_list[ii].OnDemand = this.shape_list[ii].LinuxOD;
           this.shape_list[ii].Reserved = this.shape_list[ii].Linux1yrNURI;
         } else if (this.databaseType=="ec2fsxn") {
           this.shape_list[ii].OnDemand = this.shape_list[ii].LinuxOD;
           this.shape_list[ii].Reserved = this.shape_list[ii].Linux1yrNURI;   
         } else if (this.databaseType=="Db2") {
           this.shape_list[ii].OnDemand = this.shape_list[ii].Db2_OD;
           this.shape_list[ii].Reserved = this.shape_list[ii].Db2_1yrNURI;
           this.shape_list[ii].SavingsPlan = this.shape_list[ii].Db2_1yrNUSP;
         } else if (this.databaseType=="Aurora") {
           this.shape_list[ii].OnDemand = this.shape_list[ii].AuroraPGOD;
           this.shape_list[ii].Reserved = this.shape_list[ii].AuroraPG1yrNURI;
           this.shape_list[ii].SavingsPlan = this.shape_list[ii].AuroraPG1yrNUSP;
           this.shape_list[ii].SavingsPlanOptim = this.shape_list[ii].AuroraPGOptim1yrNUSP;
           this.shape_list[ii].OnDemandOptim = this.shape_list[ii].AuroraPGOptimOD;
           if ( (this.shape_list[ii].AuroraPG1yrNURI*1.3 > 0) && (this.shape_list[ii].AuroraPGOptimOD*1 > 0) ){
             this.shape_list[ii].ReservedOptim = (this.shape_list[ii].AuroraPG1yrNURI*1.3).toFixed(3);
           }   
         }
         

      } 
      
      
      
      

      
      //define compare function
      var databaseType = this.databaseType;
      var form = this.form;
      
       function compareShape(a, b) {
         
         var itemA = 0;
         var itemB = 0;
         
        if (databaseType=="RDS") {
          if (form.optgoal_algo=="min_license") {
           itemA = a.VCPU * 10000 + older_generation_cost_adjustment(((form.useRI_algo=='RI') && a.Oracle1yrNURI * 1 > 0 ? a.Oracle1yrNURI*1 : a.OracleOD*1), a);
           itemB = b.VCPU * 10000 + older_generation_cost_adjustment(((form.useRI_algo=='RI') && b.Oracle1yrNURI * 1 > 0 ? b.Oracle1yrNURI*1 : b.OracleOD*1), b);
          } else {  
           itemA = older_generation_cost_adjustment(((form.useRI_algo=='RI') && a.Oracle1yrNURI * 1 > 0 ? a.Oracle1yrNURI*1 : a.OracleOD*1), a) * 10000 + a.VCPU*1 ;
           itemB = older_generation_cost_adjustment(((form.useRI_algo=='RI') && b.Oracle1yrNURI * 1 > 0 ? b.Oracle1yrNURI*1 : b.OracleOD*1), b) * 10000 + b.VCPU*1 ;
          } 
        } else if (databaseType=="RDS-Custom") {
          if (form.optgoal_algo=="min_license") {
           itemA = a.VCPU * 10000 + older_generation_cost_adjustment(((form.useRI_algo=='RI') && a.OracleCustom1yrNURI * 1 > 0 ? a.OracleCustom1yrNURI*1 : a.OracleCustomOD*1), a);
           itemB = b.VCPU * 10000 + older_generation_cost_adjustment(((form.useRI_algo=='RI') && b.OracleCustom1yrNURI * 1 > 0 ? b.OracleCustom1yrNURI*1 : b.OracleCustomOD*1), b);
          } else {  
           itemA = older_generation_cost_adjustment(((form.useRI_algo=='RI') && a.OracleCustom1yrNURI * 1 > 0 ? a.OracleCustom1yrNURI*1 : a.OracleCustomOD*1), a) * 10000 + a.VCPU*1 ;
           itemB = older_generation_cost_adjustment(((form.useRI_algo=='RI') && b.OracleCustom1yrNURI * 1 > 0 ? b.OracleCustom1yrNURI*1 : b.OracleCustomOD*1), b) * 10000 + b.VCPU*1 ;
          } 
        } else if (databaseType=="RDS-SE2") {
          // if (form.optgoal_algo=="min_license") {
           itemA = a.VCPU * 10000 + older_generation_cost_adjustment(((form.useRI_algo=='RI') && a.OracleLIse2_1yrNURI * 1 > 0 ? a.OracleLIse2_1yrNURI*1 : a.OracleLIse2_OD*1), a);
           itemB = b.VCPU * 10000 + older_generation_cost_adjustment(((form.useRI_algo=='RI') && b.OracleLIse2_1yrNURI * 1 > 0 ? b.OracleLIse2_1yrNURI*1 : b.OracleLIse2_OD*1), b);
          // } else {  
          // itemA = ((form.useRI_algo=='RI') && a.OracleLIse2_1yrNURI * 1 > 0 ? a.OracleLIse2_1yrNURI*1 : a.OracleLIse2_OD*1) * 10000 + a.VCPU*1 ;
          // itemB = ((form.useRI_algo=='RI') && b.OracleLIse2_1yrNURI * 1 > 0 ? b.OracleLIse2_1yrNURI*1 : b.OracleLIse2_OD*1) * 10000 + b.VCPU*1 ;
          // } 
        } else if (databaseType=="EC2") {
          if (form.optgoal_algo=="min_license") {
           itemA = a.VCPU * 10000 + older_generation_cost_adjustment(((form.useRI_algo=='RI') && a.Linux1yrNURI * 1 > 0 ? a.Linux1yrNURI*1 : a.LinuxOD*1), a);
           itemB = b.VCPU * 10000 + older_generation_cost_adjustment(((form.useRI_algo=='RI') && b.Linux1yrNURI * 1 > 0 ? b.Linux1yrNURI*1 : b.LinuxOD*1), b);
          } else {  
           itemA = older_generation_cost_adjustment(((form.useRI_algo=='RI') && a.Linux1yrNURI * 1 > 0 ? a.Linux1yrNURI*1 : a.LinuxOD*1), a) * 10000 + a.VCPU*1 ;
           itemB = older_generation_cost_adjustment(((form.useRI_algo=='RI') && b.Linux1yrNURI * 1 > 0 ? b.Linux1yrNURI*1 : b.LinuxOD*1), b) * 10000 + b.VCPU*1 ;
          } 
        } else if (databaseType=="ec2fsxn") {
          if (form.optgoal_algo=="min_license") {
           itemA = a.VCPU * a.OracleCoreFactor * 10000 + older_generation_cost_adjustment(((form.useRI_algo=='RI') && a.Linux1yrNURI * 1 > 0 ? a.Linux1yrNURI*1 : a.LinuxOD*1), a);
           itemB = b.VCPU * b.OracleCoreFactor * 10000 + older_generation_cost_adjustment(((form.useRI_algo=='RI') && b.Linux1yrNURI * 1 > 0 ? b.Linux1yrNURI*1 : b.LinuxOD*1), b);
          } else {  
           itemA = older_generation_cost_adjustment(((form.useRI_algo=='RI') && a.Linux1yrNURI * 1 > 0 ? a.Linux1yrNURI*1 : a.LinuxOD*1), a) * 10000 + a.VCPU*1 ;
           itemB = older_generation_cost_adjustment(((form.useRI_algo=='RI') && b.Linux1yrNURI * 1 > 0 ? b.Linux1yrNURI*1 : b.LinuxOD*1), b) * 10000 + b.VCPU*1 ;
          }   
        } else if (databaseType=="Aurora") {
           itemA = older_generation_cost_adjustment(((form.useRI_algo=='RI') && a.AuroraPG1yrNURI * 1 > 0 ? a.AuroraPG1yrNURI*1 : ( a.AuroraPGOD*1>0 ? a.AuroraPGOD*1 : a.AuroraPGOptimOD*1) ), a) * 10000 + a.VCPU*1 ;
           itemB = older_generation_cost_adjustment(((form.useRI_algo=='RI') && b.AuroraPG1yrNURI * 1 > 0 ? b.AuroraPG1yrNURI*1 : ( b.AuroraPGOD*1>0 ? b.AuroraPGOD*1 : b.AuroraPGOptimOD*1) ), b) * 10000 + b.VCPU*1 ;
        } else if (databaseType=="Db2") {
           itemA = older_generation_cost_adjustment(((form.useRI_algo=='RI') && a.Db2_1yrNURI * 1 > 0 ? a.Db2_1yrNURI*1 : a.Db2_OD*1  ), a) * 10000 + a.VCPU*1 ;
           itemB = older_generation_cost_adjustment(((form.useRI_algo=='RI') && b.Db2_1yrNURI * 1 > 0 ? b.Db2_1yrNURI*1 : b.Db2_OD*1  ), b) * 10000 + b.VCPU*1 ;
        }

        let comparison = 0;
        if (itemA > itemB) {
          comparison = 1;
        } else if (itemA < itemB) {
          comparison = -1;
        } else if (itemA == itemB) {
          // final sort is by Name in REVERSE order.  This should make r6i.xlarge appear ahead of r5.xlarge
          if (a.Name.split(".")[0] > b.Name.split(".")[0]) {
            comparison = -1;
          } else if (a.Name.split(".")[0] < b.Name.split(".")[0]) {
            comparison = 1;
          }
        }
        return comparison;
      }
      
     //sort
     this.shape_list.sort(compareShape);

      //see what rows match...
      var firstMatch=0;
      
      for (var ii = 0; ii < this.shape_list.length; ii++) {

         this.shape_list[ii].Match='No';
         // cost multiplier used when ranking by cost (1.0 = newest generation)
         this.shape_list[ii].GenFactor=older_generation_factor(this.shape_list[ii]);
         this.shape_list[ii]._rowVariant='secondary';
         
         //if there is a shapeNameFilter apply it now
         if ( (this.shapeNameFilter=="") || ( this.shape_list[ii].Name.indexOf(this.shapeNameFilter.toLowerCase()) >= 0) ) {
             
             if (this.databaseType=="Aurora") {
               if (
                  this.shape_list[ii].VCPU * 1 >= this.ec2.VCPU * 1 &&
                  this.shape_list[ii].Memory * 1 >= this.ec2.Memory * 1 &&
                  this.shape_list[ii].Network / 8 >= this.ec2.Throughput * 1 
                ) {
                  this.shape_list[ii].Match='Yes';
                  this.shape_list[ii]._rowVariant='success';
                  if (firstMatch==0) firstMatch=ii;
                }  
               
             } else if (this.databaseType=="ec2fsxn") {
               if (
                  this.shape_list[ii].VCPU * 1 >= this.ec2.VCPU * 1 &&
                  this.shape_list[ii].Memory * 1 >= this.ec2.Memory * 1 &&
                  this.shape_list[ii].Network / 8 >= this.ec2.Throughput * 1 
                ) {
                  this.shape_list[ii].Match='Yes';
                  this.shape_list[ii]._rowVariant='success';
                  if (firstMatch==0) firstMatch=ii;
                }  
               
             } else {
               if (
                  this.shape_list[ii].VCPU * 1 >= this.ec2.VCPU * 1 &&
                  this.shape_list[ii].Memory * 1 >= this.ec2.Memory * 1 &&
                  this.shape_list[ii].Throughput * 1 >= this.ec2.Throughput * 1 &&
                  this.shape_list[ii].IOPS * 1 >= this.ebs.IOPS * 1
                ) {
                  this.shape_list[ii].Match='Yes';
                  this.shape_list[ii]._rowVariant='success';
                  if (firstMatch==0) firstMatch=ii;
                }  
             }
           
         }

      } 

      //showMatchesOnly?
      if (this.showMatchesOnly=="Y") {
        this.shape_list = this.shape_list.filter(value => (value.Match=='Yes')  );
      }  
            
      //adjust table
      
      if (this.databaseType=='Aurora') {
        this.inputFields = [
        {Match: {
          label: "Match?",
          sortable: true
        }},
        {Name: {
          label: typeLabel,
          sortable: true
        }},
        {Reserved: {
          label: "Reserved $/hr",
          sortable: true
        }},
          {SavingsPlan: {
            label: "SavingsPlan $/hr",
            sortable: true
          }},
        {OnDemand: {
          label: "OnDemand $/hr",
          sortable: true
        }},
        {ReservedOptim: {
          label: "IO-Optimized Reserved $/hr",
          sortable: true
        }},
          {SavingsPlanOptim: {
            label: "IO-Optimized SavingsPlan $/hr",
            sortable: true
          }},
        {OnDemandOptim: {
          label: "IO-Optimized OnDemand $/hr",
          sortable: true
        }},
        {VCPU: {
          label: "VCPU",
          sortable: true
        }},
        {Memory: {
          label: "Memory GB",
          sortable: true
        }},
       {Network: {
          label: "Throughput (Network MB/s)",
          sortable: true
        }}
      ];
      } else if (this.databaseType=='ec2fsxn') {
        this.inputFields = [
        {Match: {
          label: "Match?",
          sortable: true
        }},
        {Name: {
          label: typeLabel,
          sortable: true
        }},
        {Reserved: {
          label: "Reserved $/hr",
          sortable: true
        }},
        {OnDemand: {
          label: "OnDemand $/hr",
          sortable: true
        }},
        {VCPU: {
          label: "VCPU",
          sortable: true
        }},
        {GeekbenchCoreScoreRounded: {
          label: "Single Core Benchmark",
          sortable: true
        }},
        {Memory: {
          label: "Memory GB",
          sortable: true
        }},
       {Network: {
          label: "Network Throughput (MB/s)",
          sortable: true
        }},  
       {Throughput: {
          label: "EBS Throughput (MB/s)",
          sortable: true
        }},
       {IOPS: {
          label: "IOPS",
          sortable: true
        }}
      ];
      } else if ((this.databaseType=='RDS')|| (this.databaseType=='Db2')) {
        this.inputFields = [
          {Match: {
            label: "Match?",
            sortable: true
          }},
          {Name: {
            label: typeLabel,
            sortable: true
          }},
          {Reserved: {
            label: "Reserved $/hr",
            sortable: true
          }},
          {SavingsPlan: {
            label: "SavingsPlan $/hr",
            sortable: true
          }},
          {OnDemand: {
            label: "OnDemand $/hr",
            sortable: true
          }},
          {VCPU: {
            label: "VCPU",
            sortable: true
          }},
          {Memory: {
            label: "Memory GB",
            sortable: true
          }},
         {Throughput: {
            label: "Storage Throughput (MB/s)",
            sortable: true
          }},
         {IOPS: {
            label: "IOPS",
            sortable: true
          }}
        ];
      }
      else  {
        this.inputFields = [
        {Match: {
          label: "Match?",
          sortable: true
        }},
        {Name: {
          label: typeLabel,
          sortable: true
        }},
        {Reserved: {
          label: "Reserved $/hr",
          sortable: true
        }},
        {OnDemand: {
          label: "OnDemand $/hr",
          sortable: true
        }},
        {VCPU: {
          label: "VCPU",
          sortable: true
        }},
        {Memory: {
          label: "Memory GB",
          sortable: true
        }},
       {Network: {
          label: "Network Throughput (MB/s)",
          sortable: true
        }},
       {Throughput: {
          label: "Storage Throughput (MB/s)",
          sortable: true
        }},
       {IOPS: {
          label: "IOPS",
          sortable: true
        }}
      ];
      
      }
      
      //update disclaimers
      var disclaimer_params = {
        use_se: this.databaseType=="RDS-SE2",
        use_rac: this.databaseType=="RAC",
        optgoal_algo: this.form.optgoal_algo,
        aurora_algo: (this.databaseType=="Aurora" ? "auro2" : "auro1"),
        ec2fsxn_algo: (this.databaseType=="ec2fsxn" ? "Y" : "N")
      };
      
      this.disclaimerLists = disclaimers("shapes","page",disclaimer_params, this.regionInfo);
      
      if (this.showMatchesOnly!="Y") {
        setTimeout(() => {
           this.scrollToRow(firstMatch-1);
          }, 0);
      }

    }  //end changeDatabaseType

  } //end methods:

};
</script>

<style>
</style>
